import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import BannerSection from '../components/BannerSection';
import WhyChooseSection from '../components/WhyChooseSection';
import ProductsSection from '../components/ProductsSection';
import AboutUsSection from '../components/AboutUsSection';
import QualityBanner from '../components/QualityBanner';
import ProcessSection from '../components/ProcessSection';
import MadeForEveryoneSection from '../components/MadeForEveryoneSection';
import TeamSection from '../components/TeamSection';
import FooterSection from '../components/FooterSection';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Bitejoy - Premium Date Dry Fruit Chocolates & Peanut Butter Bites</title>
        <meta
          name="description"
          content="Bitejoy Chocolates offers premium date dry fruit chocolates and peanut butter bites made with Dubai dates, handpicked dry fruits, and no added sugar. Perfect for kids, families, and fitness lovers."
        />
        <meta
          name="keywords"
          content="Bitejoy, premium chocolates, date chocolates, dry fruit chocolates, peanut butter bites, healthy chocolates, Dubai dates, no added sugar, handcrafted chocolates"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="Bitejoy - Premium Date Dry Fruit Chocolates" />
        <meta
          property="og:description"
          content="Handcrafted premium chocolates with Dubai dates, dry fruits, and no added sugar. Made for everyone!"
        />
        <meta
          property="og:image"
          content="https://s3.ap-south-1.amazonaws.com/btoc-ecom-prod/06d647f7-2bba-4e47-a7ca-b51e59ea93e5/HTMLPage/98978440-f618-11f0-9284-8bc35c03e9d6/1767899345026.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bitejoy.com" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bitejoy - Premium Date Dry Fruit Chocolates" />
        <meta
          name="twitter:description"
          content="Handcrafted premium chocolates with Dubai dates, dry fruits, and no added sugar."
        />
        <meta
          name="twitter:image"
          content="https://s3.ap-south-1.amazonaws.com/btoc-ecom-prod/06d647f7-2bba-4e47-a7ca-b51e59ea93e5/HTMLPage/98978440-f618-11f0-9284-8bc35c03e9d6/1767899345026.jpg"
        />
      </Helmet>

      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <BannerSection />
        <div className="space" id="order"></div>
        <WhyChooseSection />
        <ProductsSection />
        <AboutUsSection />
        <QualityBanner />
        <ProcessSection />
        <MadeForEveryoneSection />
        <TeamSection />
        <div className="contact" id="contact"></div>
      </main>
      <FooterSection />
    </>
  );
};

export default Home;
